import React, { useState, useRef } from "react";
import { Dropdown, ButtonGroup, Button } from "react-bootstrap";
import HelpCenter from "../Shared/HelpCenter/HelpCenter";
import { HelpCenterContextProvider } from "../Shared/HelpCenter/Context/HelpCenterContext";
import { HubspotProvider } from "@aaronhayes/react-use-hubspot-form";
const Header = ({
	header,
	headerLinkText,
	headerLinkClicked,
	headerIcon,
	headerDescription,
	PermissionText,
	children,
	actionText,
	actionTitle,
	actionClicked,
	actionDisabled,
	actionTestId,
	showAction,
	showOrgnization,
	actionStyle,
	buttonLeft,
	action2Text,
	action2Icon,
	action2Clicked,
	action2Disabled,
	action3Text,
	action3Icon,
	action3Clicked,
	action4Text,
	action4Icon,
	showHelpCenter,
	helpCenterFor,
	action4Clicked,
	allowBackButton,
	backButtonClicked,
	backButtonText,
	hideBorder,
	showDeleteAction,
	deleteActionText,
	deleteActionClicked,
	user
}) => {
	const [orgPopup, setOrgPopup] = useState(false);

	const blurTimeoutRef = useRef();
	const contentRef = useRef();

	const onOpen = (e) => {
		contentRef.current.focus();
	};
	const onFocus = () => {
		clearTimeout(blurTimeoutRef.current);
	};
	const onBlurTimeout = () => {
		setOrgPopup(false);
	};
	const onBlur = () => {
		clearTimeout(blurTimeoutRef.current);
		blurTimeoutRef.current = setTimeout(onBlurTimeout, 200);
	};

	return (
		<div className={`${hideBorder ? '' : 'border-bottom'}`}>
			<div className={`d-flex align-items-center justify-content-between`}>
				<div className="d-flex align-items-center">
					{header ?
						<div className={` ${showOrgnization || "header"} d-flex`}>
							<span className={`d-block ${hideBorder ? 'pt-3 ps-3 pe-3 pb-0' : 'p-3'} pe-2 ps-4 d-flex align-items-center `}>
								{headerIcon}
								<div>
									<span className="page-header">{header} <a onClick={headerLinkClicked} className="txt-link mx-1 pe-auto">{headerLinkText}</a></span>
									{headerDescription && <h6 className="mt-2 text-muted">{headerDescription}</h6>}
									{PermissionText && <small className="mt-2 text-danger d-block">{PermissionText}</small>}
								</div>
							</span>
						</div>
						:
						<span className="header-alignment"></span>
					}
					{showAction && (
						<div className="entity-first-step">
							{action3Text || action4Text ? (
								<span className="prop-down-dropdown">
									<Dropdown
										as={ButtonGroup}>
										<Button
											data-testid={actionTestId}
											className="ml-1 split-button-primary-action"
											variant={"primary"}
											onClick={actionClicked}
										>
											<i className="me-1 fas fa-plus"></i>
											{actionText}
										</Button>
										<Dropdown.Toggle className="split-button-splitter" split variant="primary" id="dropdown-split-basic" />
										<Dropdown.Menu>
											{action3Text && (
												<Dropdown.Item onClick={action3Clicked} eventKey="2">
													<span className="font-size-2">
														{action3Icon && <i className={`i-link me-1 ${action3Icon}`}></i>}
														{action3Text}
													</span>
												</Dropdown.Item>
											)}
											{action4Text && (
												<Dropdown.Item onClick={action4Clicked} eventKey="2">
													<span className="font-size-2">
														{action4Icon && <i className={`i-link me-1 ${action4Icon}`}></i>}
														{action4Text}
													</span>
												</Dropdown.Item>
											)}
										</Dropdown.Menu>
									</Dropdown>
								</span>
							) : (
								<span className="prop-down">
									<button
										data-testid={actionTestId}
										title={actionTitle}
										className={actionStyle || "btn btn-primary me-1"}
										disabled={actionDisabled}
										onClick={actionClicked}>
										<i className="me-1 fas fa-plus"></i> {actionText}
									</button>
								</span>
							)}
							{action2Text && (
								<button title={action2Text} className={actionStyle || "btn btn-color mx-1"} disabled={action2Disabled} onClick={action2Clicked}>
									{action2Text}
								</button>
							)}
						</div>
					)}
					{showDeleteAction && (
						<button title={deleteActionText} className="btn btn-danger mx-1" onClick={deleteActionClicked}>
							<i className="me-1 fas fa-times text-danger"></i> {deleteActionText}
						</button>
					)}
					{allowBackButton && (
						<button title={backButtonText} className="ms-2 btn btn-link text-dark text-decoration-none border-start" onClick={backButtonClicked}>
							<div className="d-flex">
								<img src={`${process.env.REACT_APP_DATALAKESTORAGE_URL}/${process.env.REACT_APP_DATALAKESTORAGE_RESOURCES}/images/LinkedEntity/undo.svg`} width={15} alt="Return" className="me-2" />
								<span>{backButtonText}</span>
							</div>
						</button>
					)}
				</div>
				<div className="d-flex">
					<div className="d-flex align-items-center">{children}</div>
					<div className="me-1 pe-1">
						{showHelpCenter && (
							<HelpCenterContextProvider>
								<HubspotProvider>
									<HelpCenter helpCenterFor={helpCenterFor} user={user} />
								</HubspotProvider>
							</HelpCenterContextProvider>
						)}
					</div>
				</div>
			</div>
		</div>
	)
};

/**
 * 
 * Content component
 * @param {Object} props
 * @param {boolean} props.fullHeight
 * @returns React.Component
 */
const Content = (props) => {
	return (
		<div className={"flex-grow-1 position-relative checkRuntime1" + (props.fullHeight ? " h-100" : "")}>
			<div className="top-0 bottom-0 left-0 right-0 bg-container position-absolute" style={{ overflowY: "auto", overflowX: "hidden" }}>
				{props.children}
			</div>
		</div>
	);
};

const PageContainer = (props) => {
	let { children } = props;
	return <div className="d-flex flex-column h-100">{children}</div>;
};

export { Header, Content, PageContainer };
